// extracted by mini-css-extract-plugin
export default {"root":"style_root__0rPz1","ul":"style_ul__U8FbC"};